/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum JobStatus {
    Pending = 0,
    Complete = 1,
    Legacy = 2,
    Deleted = 3,
    Cancelled = 4,
}
